import get from 'lodash/get';
import siteData from './site_data_util';
import baseSeoUtil from './base_seo_util';

export default function(state = {}) {
  const site = get(state, 'config.site');
  const siteConf = siteData || {};
  // const siteHumanReadable = get(siteConf, '[og:site_name]');
  // const author = get(state, 'author.data') || {};
  // const authorName = get(author, 'name');
  // const authorSlug = get(author, 'slug');
  const description =
    'The second annual list of LGBTQ women and nonbinary innovators in business and tech';
  const title = 'Announcing Fast Company’s second annual Queer 50 list';

  const rss = `/rss`;

  // let next = false;
  // let prev = false;

  // const page = get(state, 'authorAllFeed.data.page');
  // const totalPages = get(state, 'authorAllFeed.data.totalPages');

  // if (page < totalPages && page - 1 !== 0) {
  //   prev = `https://www.${site}.com/user/${authorSlug}/${page - 1}`;
  // }

  // if (page + 1 <= totalPages) {
  //   next = `https://www.${site}.com/user/${authorSlug}/${page + 1}`;
  // }

  const base = {
    site,
    siteConf,
    title,
    url: `https://www.${site}.com/queer-50/2021`,
    description,
    image:
      'https://assets.fastcompany.com/image/upload/v1590670864/wp-cms/uploads/2020/05/FC-Q50-LogoAnim_16x9_still.png',
    articleSection: '',
    rss,
    config: state.config,
    extend: [
      {
        link: []
      }
    ]
  };

  return baseSeoUtil(base);
}
